import { getMessageWithPlaceholders } from 'shared-locales';

import type { MandatoryReasons } from 'shared-types';
import type { ReduxRootState } from 'types';

interface Params {
  mandatoryReasons: Pick<
    MandatoryReasons,
    'groups' | 'isCourseMandatory' | 'isUserMandatory'
  >;
  messages: ReduxRootState['messages'];
}

/**
 * Turns the reasons a course is mandatory into texts to list in a tooltip,
 * e.g. ['Mandatory because of the group "Sales"', 'Set as mandatory for this
 * user']. Callers leave out the reasons they don't want to show by setting
 * them to false or an empty list.
 */
const getMandatoryReasonTexts = ({ mandatoryReasons, messages }: Params) => [
  ...(mandatoryReasons.isCourseMandatory
    ? [messages.courseMandatoryReasonCourse]
    : []),
  ...mandatoryReasons.groups.map((group) =>
    getMessageWithPlaceholders({
      message: messages.courseMandatoryReasonGroup,
      placeholders: { groupTitle: group.title }
    })
  ),
  ...(mandatoryReasons.isUserMandatory
    ? [messages.courseMandatoryReasonUser]
    : [])
];

export default getMandatoryReasonTexts;
